import { Repository } from '../../../core/context/repository';
import { type Assumption } from './entity';

export class Assumptions extends Repository<Assumption> {}
